import React, { Component } from 'react';
import AspectRatioContainer from '../aspect-ratio-container/AspectRatioContainer'
import AlignmentContainer from '../alignment-container/AlignmentContainer'
import PrequalContainer from '../prequal-container/EirPrequalContainer'


class FullWidthBanner extends Component {

  render() {
     // eir-1622
    let aspectRatio = '15-8';
    let mobaspectRatio = '10-16';
    if(this.props.height == 100) {
      aspectRatio = '15-8';
    }
    if(this.props.height == 75) {
      aspectRatio = '15-6';
        }
    if(this.props.height == 50) {
      aspectRatio = '15-4';
    }
    if(this.props.height == 30) {
      aspectRatio = '15-3';
    }
    if(this.props.height == 25) {
      aspectRatio = '15-2';
    }
    if(this.props.height == 10) {
      aspectRatio = '15-1';
    }
    if(this.props.mobileHeight == 100) {
      mobaspectRatio = '10-16';
    }
    if(this.props.mobileHeight == 75) {
      mobaspectRatio = '10-12';
    }
    if(this.props.mobileHeight == 50) {
      mobaspectRatio = '10-8';
    }
    if(this.props.mobileHeight == 30) {
      mobaspectRatio = '10-5';
    }
    if(this.props.mobileHeight == 25) {
      mobaspectRatio = '10-4';
    }
    if(this.props.mobileHeight == 10) {
      mobaspectRatio = '10-2';
    }
    if (this.props.prequal) {
      return (
        <PrequalContainer 
          title={this.props.title}
          titleHeight={this.props.titleHeight}
          backgroundImageDesktop={this.props.image.path}
          backgroundImageMobile={this.props.mobileImage.path}
          cta={this.props.cta}
          fluid={true}
        />
      );
    } else {
      return (
        // eir-1614
        
        <AspectRatioContainer className={'eir-fullwidth-banner'} xs={mobaspectRatio} md={aspectRatio}>
          <img className="img-fluid position-absolute w-100 d-none d-md-block" src={this.props.image.path} alt={this.props.image.description}/>
          <img className="img-fluid position-absolute w-100 d-md-none" src={this.props.mobileImage.path} alt={this.props.mobileImage.description}/>

          <AlignmentContainer 
            title={this.props.title}
            titleHeight={this.props.titleHeight}
            text={this.props.text}
            fluid={true}
            theme={this.props.theme}
            cta={this.props.cta}
            countdownTimer={this.props.countdownTimer} 
            alignment={this.props.alignment}
            useH1={this.props.useH1}
          />

        </AspectRatioContainer>
      );
    }
  }
}


export default FullWidthBanner;
